import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';

import { ConfigServerService, CustomHttp, BaseReportService, ApiError, MessageService } from '../../../../core';
import { PessoaTermoLGPD } from '../pessoa-termo-lgpd';
import { PessoaTermoLGPDHttpService } from './pessoa-termo-lgpd-http.service';

@Injectable({
    providedIn: 'root'
})
export class PessoaTermoLGPDImprimirHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp,
                private baseReportService: BaseReportService,
                private messageService: MessageService,
                private pessoaTermoLGPDHttpService: PessoaTermoLGPDHttpService) {
        this.pathApi = `${configServerService.getPathApi()}/pessoatermolgpd`;
    }

    /** Realiza a impressão do Termo LGPD da pessoa */
    imprimir(idPessoa: number): Promise<PessoaTermoLGPD> {
        return new Promise<PessoaTermoLGPD>((resolve, reject) => {
            this.customHttp.get<Blob>(`${this.pathApi}/${idPessoa}/imprimir`, { responseType: 'blob' })
                .pipe(
                    take(1)
                )
                .subscribe(
                    pdf => {
                        // Imprimindo termo
                        this.baseReportService.open(pdf);

                        // Carregando termo atualizado
                        this.pessoaTermoLGPDHttpService.load(idPessoa)
                            .pipe(
                                take(1)
                            )
                            .subscribe(
                                entity => {
                                    this.messageService.success('', 'Termo LGPD impresso com sucesso');
                                    resolve(entity);
                                },
                                (error: ApiError) => reject(error)
                            );
                    },
                    error => {
                        this.baseReportService.openError(error);
                        reject(error);
                    }
                );
        });
    }
}
